import { ProjectResponse } from '@/app/models/projects';
import { createContext, Dispatch, SetStateAction, useContext, useMemo, useState } from 'react';

type Filters = {
  search?: ProjectResponse | undefined;
  projectType?: string | undefined;
  branch?: string | undefined;
};

type ProjectSearchContextType = {
  filters: Filters | undefined;
  setFilters: Dispatch<SetStateAction<Filters | undefined>>;
};
const ProjectContext = createContext<undefined | ProjectSearchContextType>(undefined);

export function ProjectProvider({ children }: { children: React.ReactNode }) {
  const [filters, setFilters] = useState<Filters | undefined>(undefined);

  const contextValue = useMemo(() => ({ filters, setFilters }), [filters]);

  return <ProjectContext.Provider value={contextValue}>{children}</ProjectContext.Provider>;
}

export const useProjectSearch = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProjectSearch must be used within a ProjectProvider');
  }
  return context;
};
